import Rest from '@/services/Rest'
import qs from "qs";

export default class InformationConsentService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/informationConsentModels';

  search(parameters = {}) {
    return this.get(`/`, {
      params: parameters,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat',  skipNulls: true})
      }
    })
  }

}
